import api from './axiosNew';

export const getKpiDashboard = (params) => api.get('/api/kpi/dashboard', { params });

export const getTeamKpi = (teamId, params) => api.get(`/api/kpi/team/${teamId}`, { params });

export const getMemberKpi = (memberId, params) => api.get(`/api/kpi/member/${memberId}`, { params });

export const getKpiAiAnalysis = (data) => api.post('/api/kpi/ai-analysis', data, { timeout: 300000 });

// ── Saved AI Analysis History ──
export const saveKpiAiAnalysis = (data) => api.post('/api/kpi/ai-analysis/save', data);
export const getSavedAnalyses = () => api.get('/api/kpi/ai-analysis/history');
export const getSavedAnalysisById = (id) => api.get(`/api/kpi/ai-analysis/${id}`);
export const deleteSavedAnalysis = (id) => api.delete(`/api/kpi/ai-analysis/${id}`);
